import request from "@/utils/request";
import Qs from "qs";

/**
 * 政策列表
 * @param {*} params
 * @returns
 */
export function getLoadTable(params) {
  return request({
    url: "/policySearch/list",
    method: "post",
    data: Qs.stringify(params)
  });
}
/**
 * 政策匹配列表
 * @param {*} params
 * @returns
 */
export function getPolicyMatchTable(params) {
  return request({
    url: "/policyMatch/list",
    method: "post",
    data: Qs.stringify(params)
  });
}
/**
 * 政策匹配列表详情
 * @param {*} params
 * @returns
 */
export function policyMatchInfo(params) {
  return request({
    url: "/policyMatch/info",
    method: "post",
    data: Qs.stringify(params)
  });
}
/**
 * 政策列表
 * @param {*} params
 * @returns
 */
export function getcommonTable(params) {
  return request({
    url: "/common/policySearch/list",
    method: "post",
    data: Qs.stringify(params)
  });
}
/**
 * 政策详情
 * @param {*} params
 * @returns
 */
export function getPolicyInfo(params) {
  return request({
    url: "/common/generalPolicy/info",
    method: "post",
    data: Qs.stringify(params)
  });
}
/**
 * 政策咨询政策详情
 * @param {*} params
 * @returns
 */
export function getChatInfo(params) {
  return request({
    url: "/common/generalPolicy/info2",
    method: "post",
    data: Qs.stringify(params)
  });
}
/**
 * 添加订阅
 * @param {*} params
 * @returns
 */
export function updateSubscribeInfo(params) {
  return request({
    url: "/myPolicy/updateUserInfo",
    method: "post",
    data: Qs.stringify(params)
  });
}
/**
 * 智能推送
 * @param {*} params
 * @returns
 */
export function znList(params) {
  return request({
    url: "/myPolicy/znList",
    method: "post",
    data: Qs.stringify(params)
  });
}
/**
 * 我的政策--政策订阅
 * @param {*} params
 * @returns
 */
export function myPolicyList(params) {
  return request({
    url: "/myPolicy/list",
    method: "post",
    data: Qs.stringify(params)
  });
}
/**
 * 检查是否具备申报条件
 * @param {*} params
 * @returns
 */
export function declareAble(params) {
  return request({
    url: "/policy/declareAble",
    method: "post",
    data: Qs.stringify(params)
  });
}
/**
 * policy提交审核
 * @param {*} params
 * @returns
 */
export function savePolicyEnt(params) {
  return request({
    url: "/policy/savePolicyEnt",
    method: "post",
    data: Qs.stringify(params)
  });
}
/**
 * 查政策信息
 * @param {*} params
 * @returns
 */
export function getPolicyEnt(params) {
  return request({
    url: "/policy/getPolicyEnt",
    method: "post",
    data: Qs.stringify(params)
  });
}
/**
 * 个人中心---申报进度
 * @param {*} params
 * @returns
 */
export function declareList(params) {
  return request({
    url: "/policy/declareList",
    method: "post",
    data: Qs.stringify(params)
  });
}
/**
 * 政策---关注||取消关注
 * @param {*} params
 * @returns
 */
export function attention(params) {
  return request({
    url: "/policy/attention",
    method: "post",
    data: Qs.stringify(params)
  });
}
/**
 * 个人中心--我的关注
 * @param {*} params
 * @returns
 */
export function getAttentionList(params) {
  return request({
    url: "/myPolicy/attentionList",
    method: "post",
    data: Qs.stringify(params)
  });
}
/**************************************政策大讲堂 */
/*** 列表
 * @param {*} params
 * @returns
 */
export function getForumTable(params) {
  return request({
    url: "/policy-unscramble/list",
    method: "post",
    data: Qs.stringify(params)
  });
}
/** * 根据ID获取基本信息
 * @param {*} params
 * @returns
 */
export function getForuminfo(params) {
  return request({
    url: "/policy-unscramble/info",
    method: "post",
    data: Qs.stringify(params)
  });
}
/** * 关注取消关注
 * @param {*} params
 * @returns
 */
export function getForumStar(params) {
  return request({
    url: "/policy-unscramble/star",
    method: "post",
    data: Qs.stringify(params)
  });
}
/** * 个人中心---我的收藏
 * @param {*} params
 * @returns
 */
export function getStarList(params) {
  return request({
    url: "/policy-unscramble/starList",
    method: "post",
    data: Qs.stringify(params)
  });
}
